import React from 'react';
import PropTypes from 'prop-types';
import styles from "./ComponentAutoRenewMessage.scss";
import Toggle from "../../common/primitives/Toggle";

import {__t} from "../../common/lang/text-resource";

export default function ComponentAutoRenewMessage({autoRenewChecked, onChangeAutoRenew}) {

	return (
		<div data-layout="col 12 padding-top--12">
			<div data-layout="row gutter-none start">
				<div data-layout="col 3" className={styles.autoRenewIMG}>
					{/*<img src={img} alt="Автоматично подновяване"/>*/}
				</div>
				<div data-layout={`col 9 padding-left--15`}>
					<div className={styles.renewWrap} data-layout="padding-bottom--xs">
						{__t("Автоматично подновяване на услугите.")}
						{/*{__t("Спестете си време и излишни усилия!")}&nbsp;*/}
						{/*<br/>*/}
						{/*{__t("Включете автоматично подновяване")}&nbsp;*/}
						{/*<br/>*/}
						{/*{__t("за избраните услуги.")}*/}
					</div>
					<Toggle isActive={autoRenewChecked} onChange={onChangeAutoRenew}/>
					<span data-layout="padding-left--sm">
						<a
							href={__t('https-help-superhosting-bg-automatic-payments-terda9f07')}
							target="_blank" rel="noreferrer noopener">{__t('Общи условия')}</a>
					</span>
				</div>
			</div>
		</div>
	)
}
ComponentAutoRenewMessage.propTypes = {
	autoRenewChecked: PropTypes.bool.isRequired,
	onChangeAutoRenew: PropTypes.func.isRequired
}